const { userAgent } = window.navigator

export const isMobile = /iPhone|iPad|Android/.test(userAgent)
